import type { Tag } from "@/content/types";
import { URLS } from "@/lib/consts";

export const TAGS: Tag[] = [
  {
    key: "accounting",
    label: "ACCOUNTING",
    href: URLS.SERVICES.ACCOUNTING.ROOT,
  },
  {
    key: "advisory",
    label: "ADVISORY",
    href: URLS.SERVICES.ADVISORY.ROOT,
  },
  {
    key: "audit",
    label: "AUDIT",
    href: URLS.SERVICES.AUDIT.ROOT,
  },
  {
    key: "business",
    label: "BUSINESS",
    href: URLS.SERVICES.BUSINESS.ROOT,
  },
  {
    key: "individual",
    label: "INDIVIDUAL",
    href: URLS.SERVICES.INDIVIDUAL.ROOT,
  },
  {
    key: "tax",
    label: "TAX",
    href: URLS.SERVICES.TAX.ROOT,
  },
];

export const TAGS_BY_KEY = Object.fromEntries(TAGS.map(t => [t.key, t]));
